module.exports = __webpack_public_path__ + "img/serve4.3f744664.png";